import { get } from 'unified-navigation-ui/utils/tempStorage';
export default function isNotificationsDisable() {
  return get('NOTIFICATIONS_DISABLE') === 'true';
}